import { trackEvent } from 'utils/analytics';

// Types

export type MainStoreGMapsErrorState = {
  errored: boolean;
};

type SetGMapsErrorAction = {
  type: 'SET_GMAPS_ERROR';
};
export type Action = SetGMapsErrorAction;

// Reducer

const initialState = {
  errored: false,
};

export function gMapsErrorReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreGMapsErrorState = initialState,
  action: Action
) {
  switch (action.type) {
    case 'SET_GMAPS_ERROR':
      return {
        errored: true,
      };

    default:
      return state;
  }
}

// Actions

export const setGMapsError = (error: string): SetGMapsErrorAction => {
  trackEvent('Google Maps API Error', {
    error,
  });
  return {
    type: 'SET_GMAPS_ERROR',
  };
};
